import { string } from 'yup';
import { ValidationConfigNL } from '@/src/lib/validation/validation.config';
import { RegisterFormValidationModel } from '@/src/lib/validation/models/register-form-validation.model';
import { getZipCodeMessage, getMaxLengthMessage } from '@/src/lib/dictionary/utils';

export class RegisterFormValidationModelNL extends RegisterFormValidationModel {
  public get zipCode() {
    const fieldName = this.DICT.userProfile.userData.postcode;
    const maxLength = ValidationConfigNL.ZIP_MAX_LENGTH;

    return string()
      .required(this.REQUIRED_MESSAGE)
      .matches(ValidationConfigNL.ZIP_REGEX, getZipCodeMessage(this.DICT, this.TENANT_CONFIG.zipCodeExample.default))
      .length(ValidationConfigNL.ZIP_MAX_LENGTH, getMaxLengthMessage(fieldName, maxLength, this.DICT))
      .trim();
  }
}
